import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { SearchOptionsState } from '../shared-state.interface';
import { SearchOptionsAction, SearchOptionsActionTypes } from './search-options.actions';
import { SearchOptions } from './search-options.entity';

export const searchOptionsAdapter: EntityAdapter<SearchOptions> = createEntityAdapter<SearchOptions>({
    selectId: searchOptions => searchOptions.view
});
export const emptySearchOptionsState: SearchOptionsState = searchOptionsAdapter.getInitialState();

export function SearchOptionsReducer(state = emptySearchOptionsState, action: Action): SearchOptionsState {
    const searchOptionsAction: SearchOptionsAction = action as SearchOptionsAction;
    switch (searchOptionsAction.type) {
        case SearchOptionsActionTypes.SetSelectedItemIds: {
            return searchOptionsAdapter.upsertOne(
                {
                    view: searchOptionsAction.view,
                    selectedItemIds: searchOptionsAction.itemIds
                },
                state
            );
        }

        default:
            return state;
    }
}
